import { render, staticRenderFns } from "./Index1 copy.vue?vue&type=template&id=06be5880&scoped=true"
import script from "./Index1 copy.vue?vue&type=script&lang=js"
export * from "./Index1 copy.vue?vue&type=script&lang=js"
import style0 from "./Index1 copy.vue?vue&type=style&index=0&id=06be5880&prod&scoped=true&lang=css"
import style1 from "./Index1 copy.vue?vue&type=style&index=1&id=06be5880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be5880",
  null
  
)

export default component.exports